import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { filters } from "../../api/Player"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { CloseIcon, CheckIcon, SearchIcon, CalendarIcon, TableIcon, FilterIcon, InfoIcon, OperatorIcon, PlayersIcon, SortIcon } from "./PlayerIcons"

/* Timezone — диапазоны строим в ВЫБРАННОЙ зоне, не в зоне машины */
import { nowInTz } from "../../helpers/timezone"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* Sweet alert */
import Swal from "../../helpers/alert"

/* DatePicker Settings */
registerLocale("ru", ru)


/* THE INNER SEARCH APPEARS ONLY WHEN THE LIST OF GAMES IS LONG ENOUGH TO SCROLL */
const SEARCHABLE = 8


/* Widget Player Filter */
class Filter extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            selected: "today",
            start: null,
            end: null,
            operators: [],
            tables: [],
            testers: false,
            vips: true,
            sort: "date",
            allOperators: [],
            allTables: [],
            search: "",
            operatorSearch: "",
        }
    }

    /* Periods Of The Picker */
    getPeriods = () => [
        { key: "3hours", text: t("player.last3h") },
        { key: "6hours", text: t("player.last6h") },
        { key: "12hours", text: t("player.last12h") },
        { key: "today", text: t("player.today") },
        { key: "yesterday", text: t("player.yesterday") },
        { key: "7days", text: t("player.last7days") },
        { key: "14days", text: t("player.last14days") },
        { key: "30days", text: t("player.last30days") },
        { key: "month", text: t("player.thisMonth") },
        { key: "prevmonth", text: t("player.prevMonth") },
        { key: "all", text: t("player.allTime") },
    ]

    /* Orders Of The List */
    getSorts = () => [
        { key: "date", text: t("plr.sortDate"), tone: "blue" },
        { key: "ggr", text: t("plr.sortGgr"), tone: "green" },
        { key: "ggr-asc", text: t("plr.sortGgrAsc"), tone: "red" },
        { key: "debit", text: t("plr.sortDebit"), tone: "orange" },
        { key: "rounds", text: t("plr.sortRounds"), tone: "slate" },
        { key: "name", text: t("plr.sortName"), tone: "slate" },
    ]

    /* Open Action */
    open = ({ selected = "today", start = null, end = null, operators = [], tables = [], testers = false, vips = true, sort = "date" }) => {

        this.setState({
            visible: true,
            selected,
            start,
            end,
            operators: [...operators],
            tables: [...tables],
            testers,
            vips,
            sort,
            search: "",
            operatorSearch: "",
        }, () => {
            this.load()
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false })
    }

    /* A Section The Owner Of The Filter Turned Off — the rounds of one player need no operators */
    hidden = (name) => {

        /* Fields */
        const { hide } = this.props

        /* Check Input */
        if (!hide || !Array.isArray(hide)) {
            return false
        }

        /* Send Result */
        return hide.includes(name)
    }

    /* Load Action — the operators and the games come strictly inside the scope of the token,
     * so no option of the filter can ever reach a foreign studio */
    load = () => {

        /* Check Loaded */
        if (this.state.allOperators.length > 0 || this.state.allTables.length > 0) {
            return
        }

        /* Send to REST API */
        filters().then((response) => {
            if (response.status === 200) {
                this.setState({ allOperators: response.data.operators, allTables: response.data.tables })
            }
        }).catch(() => {
            this.setState({ allOperators: [], allTables: [] })
        })

    }

    /* Games Of The Search */
    getTables = () => {

        /* Fields */
        const { allTables, search } = this.state
        const value = search.trim().toLowerCase()

        /* Check Search */
        if (value === "") {
            return allTables
        }

        /* Send Result */
        return allTables.filter((item) => {

            const name = String(utils.checkValue(item.name, "")).toLowerCase()
            const slug = String(utils.checkValue(item.slug, "")).toLowerCase()
            const studio = String(utils.checkValue(item.studioName, "")).toLowerCase()

            return name.includes(value) || slug.includes(value) || studio.includes(value)
        })
    }

    /* Check Game */
    checkTable = (table) => {
        return this.state.tables.findIndex((item) => parseInt(item.id) === parseInt(table.id)) > -1
    }

    /* Toggle Game */
    toggleTable = (table) => {

        /* Fields */
        const { tables } = this.state

        /* Get Index */
        const index = tables.findIndex((item) => parseInt(item.id) === parseInt(table.id))

        /* Check Index */
        if (index > -1) {
            tables.splice(index, 1)
        }
        else {
            tables.push(table)
        }

        this.setState({ tables })
    }

    /* Select Every Game Of The Search — an empty selection already means every game */
    selectTables = () => {
        this.setState({ tables: [...this.getTables()] })
    }

    /* Deselect Every Game */
    deselectTables = () => {
        this.setState({ tables: [] })
    }

    /* Operators Of The Section — the answer of the API is the source of truth, the store of the panel
     * is the fallback while the answer is still on its way or when it never arrives */
    getAllOperators = () => {

        /* Fields */
        const { allOperators } = this.state
        const { operators } = this.props

        /* Check Answer */
        if (allOperators.length > 0) {
            return allOperators
        }

        /* Check Store */
        if (operators && Array.isArray(operators)) {
            return operators
        }

        /* Send Result */
        return []
    }

    /* Operators Of The Search */
    getOperators = () => {

        /* Fields */
        const { operatorSearch } = this.state
        const allOperators = this.getAllOperators()
        const value = operatorSearch.trim().toLowerCase()

        /* Check Search */
        if (value === "") {
            return allOperators
        }

        /* Send Result */
        return allOperators.filter((item) => {

            const name = String(utils.checkValue(item.name, "")).toLowerCase()
            const slug = String(utils.checkValue(item.slug, "")).toLowerCase()

            return name.includes(value) || slug.includes(value)
        })
    }

    /* Check Operator */
    checkOperator = (operator) => {
        return this.state.operators.findIndex((item) => parseInt(item.id) === parseInt(operator.id)) > -1
    }

    /* Toggle Operator */
    toggleOperator = (operator) => {

        /* Fields */
        const { operators } = this.state

        /* Get Index */
        const index = operators.findIndex((item) => parseInt(item.id) === parseInt(operator.id))

        /* Check Index */
        if (index > -1) {
            operators.splice(index, 1)
        }
        else {
            operators.push(operator)
        }

        this.setState({ operators })
    }

    /* Select Every Operator Of The Search — an empty selection already means every operator */
    selectOperators = () => {
        this.setState({ operators: [...this.getOperators()] })
    }

    /* Deselect Every Operator */
    deselectOperators = () => {
        this.setState({ operators: [] })
    }

    /* Select Period */
    select = (selected) => {

        /* All Period — no border goes to the request */
        if (selected === "all") {
            this.setState({ start: null, end: null, selected })
            return
        }

        /* Hours */
        const hours = { "3hours": 3, "6hours": 6, "12hours": 12 }

        if (hours[selected]) {
            this.setState({ start: nowInTz().subtract(hours[selected], "hours").toDate(), end: nowInTz().toDate(), selected })
            return
        }

        /* Today */
        if (selected === "today") {
            this.setState({ start: nowInTz().startOf("day").toDate(), end: nowInTz().endOf("day").toDate(), selected })
            return
        }

        /* Yesterday */
        if (selected === "yesterday") {
            this.setState({
                start: nowInTz().subtract(1, "day").startOf("day").toDate(),
                end: nowInTz().subtract(1, "day").endOf("day").toDate(),
                selected,
            })
            return
        }

        /* Days */
        const days = { "7days": 6, "14days": 13, "30days": 29 }

        if (days[selected] !== undefined) {
            this.setState({ start: nowInTz().subtract(days[selected], "days").startOf("day").toDate(), end: nowInTz().endOf("day").toDate(), selected })
            return
        }

        /* This Month */
        if (selected === "month") {
            this.setState({ start: nowInTz().startOf("month").toDate(), end: nowInTz().endOf("month").toDate(), selected })
            return
        }

        /* Previous Month */
        if (selected === "prevmonth") {
            this.setState({
                start: nowInTz().subtract(1, "month").startOf("month").toDate(),
                end: nowInTz().subtract(1, "month").endOf("month").toDate(),
                selected,
            })
        }

    }

    /* Reset Action — the owner of the filter decides what an empty period means for it */
    reset = () => {

        /* Fields */
        const { defaultPeriod } = this.props

        this.setState({
            operators: [],
            tables: [],
            testers: false,
            vips: true,
            sort: "date",
            search: "",
            operatorSearch: "",
        }, () => this.select(defaultPeriod ? defaultPeriod : "today"))
    }

    /* Apply Action */
    apply = () => {

        /* Fields */
        const { selected, start, end, operators, tables, testers, vips, sort } = this.state
        const { apply } = this.props

        /* Check Dates */
        if (selected !== "all" && (!start || !end)) {
            Swal.fire(utils.notification(t("filter.selectDates"), "error", 2000))
            return
        }

        /* Set Apply */
        apply({ selected, start, end, operators, tables, testers, vips, sort })

        /* Close Modal */
        this.close()
    }

    /* Draw Period */
    _period = () => {

        /* Fields */
        const { selected, start, end } = this.state

        return (
            <div className="plr--section">

                <div className="plr--section-head">
                    <div className="plr--section-title">
                        <CalendarIcon />
                        {t("gtx.period")}
                    </div>
                </div>

                <div className="plr--chips">
                    {this.getPeriods().map((item, index) =>
                        <div
                            onClick={() => this.select(item.key)}
                            className={`plr--chip ${selected === item.key ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item.text}
                        </div>
                    )}
                </div>

                <div className="plr--range">

                    <DatePicker
                        selected={start}
                        onChange={(date) => this.setState({ start: date, selected: "period" })}
                        selectsStart
                        startDate={start}
                        endDate={end}
                        maxDate={end}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        placeholderText={t("gtx.dateFrom")}
                    />

                    <DatePicker
                        selected={end}
                        onChange={(date) => this.setState({ end: date, selected: "period" })}
                        selectsEnd
                        startDate={start}
                        endDate={end}
                        minDate={start}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        placeholderText={t("gtx.dateTo")}
                    />

                </div>

            </div>
        )
    }

    /* Draw Order */
    _sort = () => {

        /* Fields */
        const { sort } = this.state

        return (
            <div className="plr--section">

                <div className="plr--section-head">
                    <div className="plr--section-title">
                        <SortIcon />
                        {t("plr.sort")}
                    </div>
                </div>

                <div className="plr--chips">
                    {this.getSorts().map((item, index) =>
                        <div
                            onClick={() => this.setState({ sort: item.key })}
                            className={`plr--chip ${item.tone ? item.tone : ""} ${sort === item.key ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item.text}
                        </div>
                    )}
                </div>

            </div>
        )
    }

    /* Draw Players — the test and the VIP accounts are inside the list until they are dropped */
    _players = () => {

        /* Fields */
        const { testers, vips } = this.state

        return (
            <div className="plr--section">

                <div className="plr--section-head">
                    <div className="plr--section-title">
                        <PlayersIcon />
                        {t("gtx.players")}
                    </div>
                </div>

                <div className="plr--chips">

                    <div onClick={() => this.setState({ testers: !testers })} className={`plr--check ${testers ? "active" : ""}`}>
                        <div className="plr--check-box">{testers && <CheckIcon size={11} />}</div>
                        <span>{t("gtx.includeTesters")}</span>
                    </div>

                    <div onClick={() => this.setState({ vips: !vips })} className={`plr--check ${vips ? "active" : ""}`}>
                        <div className="plr--check-box">{vips && <CheckIcon size={11} />}</div>
                        <span>{t("gtx.includeVips")}</span>
                    </div>

                </div>

            </div>
        )
    }

    /* Draw Operators — a scope with a single operator has nothing to choose from */
    _operators = () => {

        /* Fields */
        const { operators, operatorSearch } = this.state
        const allOperators = this.getAllOperators()
        const list = this.getOperators()

        /* Check Operators — a scope without a single operator has nothing to choose from */
        if (allOperators.length === 0) {
            return null
        }

        return (
            <div className="plr--section">

                <div className="plr--section-head">

                    <div className="plr--section-title">
                        <OperatorIcon />
                        {t("gtx.operators")}
                        <span className={`plr--counter ${operators.length === 0 ? "empty" : ""}`}>{operators.length}</span>
                    </div>

                    <div className="plr--section-actions">
                        <span onClick={() => this.selectOperators()}>{t("filter.selectAll")}</span>
                        <span onClick={() => this.deselectOperators()}>{t("filter.deselectAll")}</span>
                    </div>

                </div>

                {allOperators.length > SEARCHABLE &&
                    <div className="plr--inner-search">
                        <SearchIcon size={14} />
                        <input value={operatorSearch} onChange={(event) => this.setState({ operatorSearch: event.target.value })} placeholder={t("plr.searchByOperator")} />
                        {operatorSearch !== "" &&
                            <div onClick={() => this.setState({ operatorSearch: "" })} className="plr--inner-search-clear">
                                <CloseIcon size={11} />
                            </div>
                        }
                    </div>
                }

                {list.length === 0 &&
                    <div className="plr--chips-empty">{t("gtx.nothingFound")}</div>
                }

                <div className="plr--chips scroll">
                    {list.map((item, index) =>
                        <div
                            onClick={() => this.toggleOperator(item)}
                            className={`plr--chip ${this.checkOperator(item) ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item.name}
                        </div>
                    )}
                </div>

            </div>
        )
    }

    /* Draw Games */
    _tables = () => {

        /* Fields */
        const { allTables, tables, search } = this.state
        const list = this.getTables()

        return (
            <div className="plr--section">

                <div className="plr--section-head">

                    <div className="plr--section-title">
                        <TableIcon />
                        {t("gtx.games")}
                        <span className={`plr--counter ${tables.length === 0 ? "empty" : ""}`}>{tables.length}</span>
                    </div>

                    <div className="plr--section-actions">
                        <span onClick={() => this.selectTables()}>{t("filter.selectAll")}</span>
                        <span onClick={() => this.deselectTables()}>{t("filter.deselectAll")}</span>
                    </div>

                </div>

                {allTables.length > SEARCHABLE &&
                    <div className="plr--inner-search">
                        <SearchIcon size={14} />
                        <input value={search} onChange={(event) => this.setState({ search: event.target.value })} placeholder={t("gtx.searchByGame")} />
                        {search !== "" &&
                            <div onClick={() => this.setState({ search: "" })} className="plr--inner-search-clear">
                                <CloseIcon size={11} />
                            </div>
                        }
                    </div>
                }

                {list.length === 0 &&
                    <div className="plr--chips-empty">{search !== "" ? t("gtx.nothingFound") : t("gtx.gamesEmpty")}</div>
                }

                <div className="plr--tables">
                    {list.map((item, index) =>
                        <div
                            onClick={() => this.toggleTable(item)}
                            className={`plr--table-chip ${this.checkTable(item) ? "active" : ""}`}
                            key={`${index}`}
                        >

                            <div className="plr--table-box">{this.checkTable(item) && <CheckIcon size={11} />}</div>

                            <div className="plr--table-text">
                                <div className="plr--table-name">{utils.checkValue(item.name, item.slug)}</div>
                                <div className="plr--table-note">{utils.checkValue(item.studioName, item.slug)}</div>
                            </div>

                        </div>
                    )}
                </div>

                <div className="plr--hint">
                    <InfoIcon />
                    <span>{t("plr.filterHint")}</span>
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="plr--modal"
                overlayClassName="plr--overlay"
                closeTimeoutMS={200}
            >

                <div className="plr--modal-header">

                    <div className="plr--modal-icon">
                        <FilterIcon size={18} />
                    </div>

                    <div className="plr--modal-head-text">
                        <h2>{t("plr.filterTitle")}</h2>
                        <p>{t("plr.filterSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="plr--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="plr--modal-body">

                    {/* Draw Period */}
                    {!this.hidden("period") && this._period()}

                    {/* Draw Order */}
                    {!this.hidden("sort") && this._sort()}

                    {/* Draw Players */}
                    {!this.hidden("players") && this._players()}

                    {/* Draw Operators */}
                    {!this.hidden("operators") && this._operators()}

                    {/* Draw Games */}
                    {!this.hidden("tables") && this._tables()}

                </div>

                <div className="plr--modal-footer space">

                    <div onClick={() => this.reset()} className="plr--button ghost">{t("gtx.reset")}</div>

                    <div className="plr--modal-footer-right">
                        <div onClick={() => this.close()} className="plr--button ghost">{t("filter.cancel")}</div>
                        <div onClick={() => this.apply()} className="plr--button primary">{t("filter.apply")}</div>
                    </div>

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    operators: state.operators,
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(Filter)
